import { render, staticRenderFns } from "./TokenExpireModal.vue?vue&type=template&id=c27bbc3c"
import script from "./TokenExpireModal.vue?vue&type=script&lang=js"
export * from "./TokenExpireModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports